import { cn } from '@neo/lib/utils'
import { Button } from '@neo/primitives/button'
import type { ReactNode } from 'react'
import {
  RegionLockedIllustration as DataRegionLockIcon,
  ErrorIllustration as ErrorIcon,
  BalanceIllustration as NoBalanceIcon,
  EmptyDataIllustration as NoDataIcon,
  DocumentsIllustration as NoDataStackIcon,
  GeographyIllustration as NoGeoPermissionsIcon,
  UpgradeIllustration as UpgradePlanRequiredIcon,
} from 'v2/shared/components/state-illustration'

const IconComponent = {
  empty_app_data: <NoDataIcon />,
  app_error: <ErrorIcon />,
  no_data_stack: <NoDataStackIcon />,
  no_balance: <NoBalanceIcon />,
  no_geo_permissions: <NoGeoPermissionsIcon />,
  data_region_locked: <DataRegionLockIcon />,
  upgrade_plan_required: <UpgradePlanRequiredIcon />,
}

interface Action {
  text: string
  onClick: () => void
  variant?: 'default' | 'outline'
}

interface EmptyStateProps {
  icon?: ReactNode
  text: ReactNode | string
  actions?: Action[]
  type?: keyof typeof IconComponent
  className?: string
}

export const EmptyState = ({ icon, text, actions, type, className }: EmptyStateProps) => {
  const Icon = type ? IconComponent[type] : icon
  return (
    <div className={cn('flex-grow relative flex flex-col items-center justify-center', className)}>
      <div className="flex flex-col items-center justify-center gap-2">
        {Icon && Icon}
        <div className="-translate-y-6 text-s-400 text-secondary flex flex-col gap-2">
          <div>{text}</div>
          {actions && actions.length > 0 && (
            <div className="flex justify-center gap-3 mt-2">
              {actions.map((action) => (
                <Button
                  key={action.text}
                  onClick={action.onClick}
                  size="sm"
                  variant={action.variant || 'outline'}
                  data-testid={`btn-${action.text.toLowerCase().replaceAll(' ', '-')}`}
                >
                  {action.text}
                </Button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
